import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: '开云体育平台提供哪些体育赛事内容？',
    answer: '开云体育平台涵盖足球、篮球、网球、电竞、乒乓球、羽毛球、F1赛车等全球主流体育项目，提供赛事资讯、赛程数据、实时比分和专业的赛事分析解读，致力于为用户打造一站式的综合体育信息服务平台。',
  },
  {
    question: '如何获取最新的体育赛事资讯？',
    answer: '您可以通过访问开云体育官网首页和分类页面，随时获取全球最新的体育赛事资讯。我们的编辑团队全天候更新内容，覆盖各大联赛和赛事的实时动态，确保您不错过任何重要体育新闻。',
  },
  {
    question: '开云体育的赛事直播功能如何？',
    answer: '开云体育提供丰富的赛事直播资源，涵盖足球、篮球、电竞等多个热门体育项目的实时直播。您可以在"正在直播"板块找到当前正在进行的比赛，获取实时比分和赛况更新。',
  },
  {
    question: '开云体育平台是否免费？',
    answer: '开云体育平台向所有用户免费开放核心的体育资讯和赛事数据服务。用户可以自由浏览体育新闻、赛事分析和比分数据，无需支付任何费用即可畅享丰富的体育内容。',
  },
  {
    question: '如何联系开云体育客服？',
    answer: '您可以通过访问"关于我们"页面获取详细的联系方式，包括客服邮箱：contact@kaiyunsports.com、客服电话：400-888-6666，我们的客服团队将竭诚为您服务。',
  },
];

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            {t('home.faq.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('home.faq.subtitle')}
          </p>
        </div>
        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="border border-background-200/60 rounded-lg overflow-hidden transition-all duration-200"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 text-lg transition-transform duration-200 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}